
import { Form } from 'element-ui'
import { Component, Vue } from 'vue-property-decorator'
import { CommonModule } from '@/store/module/common'
import { submitStore } from '@/api/store'

@Component({
  name: 'createStoreForm'
})
export default class createStoreForm extends Vue {
  get countryList() {
    return CommonModule.countryList
  }
  // 新建云仓
  createData = {
    name: '',
    country: '',
    countryName: '',
    code: ''
  }

  // 创建数据云仓
  handleCreate() {
    this.createData.name = ''
    this.createData.country = ''
    this.isEdit = false
    setTimeout(() => {
      // 加延迟是因为重置在设置值之前
      const formRef = this.$refs.createFormRef as Form
      formRef.clearValidate()
    }, 0)
  }

  // 点击选择地区触发事件
  handleSelect() {
    const res = this.countryList.find(item => item.Code === this.createData.country)
    if (res) {
      this.createData.countryName = res.name
    }
  }

  // 编辑数据云仓
  isEdit = false
  handleEdit(row: any) {
    this.createData.name = row.Name
    this.createData.country = row.CountryCode
    this.createData.countryName = row.CountryName || ''
    this.createData.code = row.Code
    this.isEdit = true
  }

  // 提交创建云仓
  handleConfirm() {
    const formRef = this.$refs.createFormRef as Form
    const platform = localStorage.getItem('menuId')
    formRef.validate((valid: any) => {
      if (valid) {
        const data = {
          platform,
          countryCode: this.createData.country,
          Name: this.createData.name,
          code: this.isEdit ? this.createData.code : undefined
        }
        submitStore(data)
          .then(() => {
            this.$message.success(this.isEdit ? '修改成功' : '创建成功')
            this.$emit('handleClose')
          })
          .catch((err: any) => {
            this.$message.error(err.msg)
          })
      }
    })
  }

  // 表单校验
  rule = {
    name: [{ required: true, trigger: 'blur', message: '请输入云仓名称' }],
    country: [{ required: true, trigger: 'change', message: '请选择国家' }]
  }
}
